import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { withTheme } from 'styled-components';
import Dropdown from './Dropdown';
import { Component } from 'react';

const moduleDropdownDefault = {
    marginX: '24px',
};

@inject('dataStore')
@observer
class ModuleDropdown extends Component<any, any> {
    render() {
        const { theme } = this.props;

        const selectItemFn = item => {
            this.props.dataStore.config.setModule(item);
        };
        return (
            <Dropdown
                items={this.props.dataStore.config.modules}
                selectItemFn={selectItemFn}
                selectedItem={this.props.dataStore.config.selectedModule}
                placeHolder={'Modules'}
                chevronIcon={'ModuleDropdownChevronIcon.svg'}
                chevronIconExpanded={'ModuleDropdownChevronIconExpanded.svg'}
                {...moduleDropdownDefault}
                {...theme.ModuleDropdown}
            />
        );
    }
}

export default withTheme(ModuleDropdown);



// WEBPACK FOOTER //
// ./src/Components/ModuleDropdown.tsx